// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductUSPs_list__RiYk0","plusCircle":"ProductUSPs_plusCircle__Z1j0e"};